// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 13:39:27
import { LinkToParentCardResult_abstract } from './../../abstract/SagaBase/Defines/LinkToParentCardResult_abstract';
export class LinkToParentCardResult extends LinkToParentCardResult_abstract {}
